import  React, { useState, useRef } from "react";
import { useForm} from "react-hook-form";
import {  useLocation  } from "react-router-dom";
import Header from "../components/Header";
import { useAxios } from "../services/useAxios";
import {alert, confirm} from "../components/MegConfirmAlert";
import { useTranslation } from 'react-i18next';
export default function OrderAddCard(props) {

    const { t } = useTranslation();

    const {register, handleSubmit, formState , setFocus, setValue, clearErrors }= useForm();

    const{errors} = formState;
    const [request] = useAxios();
    const location = useLocation();
    const onSubmit = async data=> {
        

        data.goodsName = props.data.goodsName.substr(0,39)
        data.orderId = props.data.tmprOrderId

        
        const response = await request.post("/app/order/addSimpleCardBillingAPI", data);        
        if(response.data.resultCode === 200){
            alert(response.data.resultMessage)
            props.setEasyCardList(response.data.result.billingList)
            props.closeFn()
        }else{
            alert(response.data.resultMessage)
        }
    }
    const handleKeyPress = (e,nextField ) => {      
        if(e.target.value.length === e.target.maxLength){
            if(nextField){
                setFocus(nextField);
            }          
        }else{
            e.target.value = e.target.value.replace(/[^0-9]/g, '');
            setValue(e.target.name,e.target.value.replace(/[^0-9]/g, ''), { shouldValidate: true })
            clearErrors(e.target.name)
        }
    };

    
    return(
        <div className={props.modal?'modalPage':'justPage'}>
            <Header type={props.modal?'modal':'cart'} closeFn={props.closeFn} pageTitle="카드 추가"/>
            
            <div className="pd20 pb80">
                <form onSubmit={handleSubmit(onSubmit)}>

                    <ul className="dfColG20">                        

                        <li className="idLi">
                            <p>{t(`Message.card_simple_add_card_no`)}</p>
                            <div className="dfcsG4">
                            <input 
                                
                                onKeyUp={(e)=>handleKeyPress(e, "cardNo2")}
                                type="text" 
                                maxLength={4} 
                                {...register("cardNo1", { required:"필수 응답 항목입니다."})}
                            />
                            <input 
                                onKeyUp={(e)=>handleKeyPress(e, "cardNo3")}
                                type="text" 
                                maxLength={4} 
                                {...register("cardNo2", { required:"필수 응답 항목입니다."})}
                            />
                            <input 
                                onKeyUp={(e)=>handleKeyPress(e, "cardNo4")}
                                type="text" 
                                maxLength={4} 
                                {...register("cardNo3", { required:"필수 응답 항목입니다."})}
                            />
                            <input 
                                type="text" 
                                onKeyUp={(e)=>handleKeyPress(e, "expMonth")}
                                maxLength={4} 
                                {...register("cardNo4", { required:"필수 응답 항목입니다."})}
                            />
                            </div>
                            {(errors.cardNo1 || errors.cardNo2 || errors.cardNo3|| errors.cardNo4 ) && <p role="alert" className="alertRed">{"필수 응답 항목입니다."}</p>}
                        </li>
                        <li className="idLi">
                            <p>{t(`Message.card_simple_add_validity`)}</p>
                            <div className="dfcsG4">
                                <input 
                                    type="text"
                                    onKeyUp={(e)=>handleKeyPress(e, "expYear")}
                                    maxLength={2} 
                                    placeholder="MM" {...register("expMonth", { required:"필수 응답 항목입니다.", pattern:{ value:/(0[1-9]|1[0-2])/, message:"올바른 형식이 아닙니다."}})} 
                                />
                                <input 
                                    type="text"
                                    onKeyUp={(e)=>handleKeyPress(e, "idNo")}
                                    maxLength={2}
                                    placeholder="YY" {...register("expYear", { required:"필수 응답 항목입니다."})}
                                />
                            </div>

                            {errors.expMonth  && <p role="alert" className="alertRed">{errors.expMonth.message}</p>}                            
                        </li>
                        <li className="idLi">
                            <p>{t(`Message.card_simple_add_birth`)}</p>
                            <input 
                                type="text"
                                onKeyUp={(e)=>handleKeyPress(e, "cardPw")}
                                maxLength={13} 
                                placeholder="생년월일 6자리 또는 사업자번호 13자리" {...register("idNo", { required:"필수 응답 항목입니다."})} 
                            />
                            {errors.idNo && <p role="alert" className="alertRed">{errors.idNo.message}</p>}
                        </li>
                        <li className="idLi">
                            <p>{t(`Message.card_simple_add_password`)}</p>
                            <input 
                                type="password"
                                onKeyUp={(e)=>handleKeyPress(e, "billingPassword")}
                                maxLength={2}
                                placeholder="**" {...register("cardPw", { required:"필수 응답 항목입니다.", minLength: {value:2, message:"비밀번호앞두자리를 입력해주세요."}})}
                            />
                            {errors.cardPw && <p role="alert" className="alertRed">{errors.cardPw.message}</p>}
                        </li>
                        <li className="idLi">
                            <p>간편결제 비밀번호</p>
                            <input 
                                type="password" 
                                onKeyUp={(e)=>handleKeyPress(e, null)}
                                maxLength={4}
                                placeholder="****" {...register("billingPassword", { required:"필수 응답 항목입니다.", minLength: {value:4, message:"비밀번호 4자리를 입력해주세요."}})}
                            />
                            {errors.billingPassword && <p role="alert" className="alertRed">{errors.billingPassword.message}</p>}
                        </li>
                    </ul>
                    <button type="submit" className="floatBtn">{t(`Message.saveBtn`)}</button>  
                </form>
            </div>
        </div>
    );
};